import { BackGround } from './styles'
interface Props {
    close(): void
}

const ModalBackground = ({ close }: Props) => {
    return <BackGround onClick={() => close()} />
}

export default ModalBackground
